export default __webpack_public_path__ + "static/media/white.82e604a1.svg";